import React, { Suspense, lazy } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Auth from '../../../../Layout/Auth';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import pages
import RegisterOpen from '../Pages/RegisterOpen';
const RegisterList = lazy(() => import('../Pages/RegisterList'));
const RegisterView = lazy(() => import('../Pages/RegisterView'));

/**
 * Loading component for Suspense fallback
 */
const Loading = () => (
  <LoadingOverlay
    active={false}
    spinner={<FadeLoader color={"#36D7B7"} />}
    text="Loading..."
    styles={{
      overlay: (base) => ({
        ...base,
        background: "rgba(255, 255, 255, 0.8)",
      }),
      content: (base) => ({
        ...base,
        color: "#36D7B7",
      }),
    }}
  >
    <div style={{ height: "100vh" }}></div>
  </LoadingOverlay>
);

/**
 * Business Register module routes
 */
function BusinessRegisterRoute() {
  const history = useHistory();

  return (
    <Switch>
      {/* Register List Route */}
      <Route
        exact
        path="/:lng/business/registers"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <RegisterList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/business/registers/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <RegisterList history={history} />
            </Suspense>
          </Auth>
        )}
      />

      {/* Register Open Route */}
      <Route
        exact
        path="/:lng/business/registers/open"
        render={(props) => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <RegisterOpen {...props} />
            </Suspense>
          </Auth>
        )}
      />

      {/* Register View Route */}
      <Route
        exact
        path="/:lng/business/registers/view/:slack"
        render={(props) => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <RegisterView {...props} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
}

export default BusinessRegisterRoute;
